import React, { lazy, Suspense, memo, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Loading from 'components/shared-components/Loading';
import Views from 'views';
import { getTheme, setLoading } from 'store/slices/themeSlice';

const AppLayout = lazy(() => import('./AppLayout'));
const AuthLayout = lazy(() => import('./AuthLayout'));
const PanelLayout = lazy(() => import('./PanelLayout'));

const Layouts = () => {
	const dispatch = useDispatch();
	const {panelToken, token, userType} = useSelector(state => state.auth);
	const blankLayout = useSelector(state => state.theme.blankLayout);
	const direction = useSelector(state => state.theme.direction);
	const navType = useSelector(state => state.theme.navType);
	const navCollapsed = useSelector(state => state.theme.navCollapsed);

	const isThirdParty = userType === 'THIRD_PARTY';
	const Layout = panelToken
		? PanelLayout
		: (token && !blankLayout && !isThirdParty)
			? AppLayout
			: AuthLayout;

	useEffect(() => {
    if (token && !isThirdParty) {
      dispatch(setLoading(true))
		dispatch(getTheme())
      dispatch(setLoading(false))
    }
	}, [])
	return (
		<div className='layout'>
		<Suspense fallback={<Loading cover="content"/>}>
			<Layout direction={direction} navType={navType} navCollapsed={navCollapsed}>
				<Views />
			</Layout>
		</Suspense>
		</div>
	)
}

export default memo(Layouts)
